import AuthForm from "./AuthForm";
import { useState, useEffect } from 'react';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { forms } from './AuthForm';



import Button from 'react-bootstrap/Button';

import SupportSigninButton from './SupportSigninButton';



export default function AuthContainer({maxWidth}){

  let [scene,setScene] = useState('signin');
  return (
    <div class="sg-col" style={{
      position:'relative',
      display:'flex',
      justifyContent:'center',
      maxWidth:'100%',
      //border:'3px solid red',
      height:'100%',

    }}>

    <div class="sg-col" style={{
      position:'absolute',
      width:'50%',
      top:-30,
      height:150,
      justifyContent:'center',
      left:'50%',
      transform:'translate(-50%,-100%)',
        //border:'3px solid orange',
        zIndex:100,
    }}>
    </div>

      <div class="flex-expand" style={{
        display:'flex',
        justifyContent:'center',
        //maxWidth:(maxWidth || '80%'),
        //border:'3px solid blue',
      }}>


        <div style={{ 
          position:'relative', 
          height:'100%',
        }} 
          class="auth-container white-shaddow-container flex-expand"
        >

          <div style={{
            position:'relative', 
            justifyContent:'center',
            height:'100%',
          }} class="sg-row">
            {scene !== 'signin' && (<div onClick={() => setScene('signin')}
              class="hoverable round-corners"

              style={{
                position:'absolute',
                width:30,
                height:30,
                left:0,
                top:0,
                //transform:'translate(0,-50%)',
                display:'flex',
                alignItems:'center',
                justifyContent:'center'
              }}>
              <ArrowBackIcon/>
            </div>
            )}
            {scene !== 'signin' && <div>
              {forms[scene].action}
            </div>}
          </div>
          <div 
            style={{
              //height:'100%',
              position:'relative',
              //border:'3px solid magenta',
              display:'flex', 
                justifyContent:'center',
            }}>

            <AuthForm key={scene} scene={scene} setScene={setScene}/> 
          </div>
        </div>
      </div>
    </div>
  )
}
